"use strict";

exports.__esModule = true;
exports["default"] = borderColor;

var _directionalProperty =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
require("../helpers/directionalProperty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return _directionalProperty["default"].apply(void 0, ['borderColor'].concat(values));
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/shorthands/borderColor.js
// module id = 1039
// module chunks = 27180705640166